import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import { BULK_MAX } from '../prospectOptions';

/**
 * ProspectSelectionBar - Ações dos contatos marcados na lista da Prospecção.
 * @param {Object} props
 * @param {number} props.count
 * @param {Function} props.onSend
 * @param {Function} props.onClear
 */
function ProspectSelectionBar({ count, onSend, onClear }) {
  if (count === 0) return null;
  const overLimit = count > BULK_MAX;

  return (
    <Box
      sx={{
        display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1.5, mb: 2, px: 2, py: 1.25,
        borderRadius: '12px', bgcolor: '#EEF4FF', border: '1px solid #D6E4FF',
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {count === 1 ? '1 contato selecionado' : `${count} contatos selecionados`}
      </Typography>
      {overLimit && (
        <Typography variant="body2" color="error">
          Até {BULK_MAX} por vez. Desmarque {count - BULK_MAX}.
        </Typography>
      )}
      <Box sx={{ flex: 1 }} />
      <Button size="small" onClick={onClear} sx={{ textTransform: 'none', fontWeight: 600 }}>
        Limpar
      </Button>
      <Button
        size="small"
        variant="contained"
        startIcon={<SendOutlinedIcon fontSize="small" />}
        onClick={onSend}
        disabled={overLimit}
        sx={{ borderRadius: '8px', textTransform: 'none', fontWeight: 600 }}
      >
        Enviar mensagem
      </Button>
    </Box>
  );
}

export default ProspectSelectionBar;
